import * as actionTypes from '../Global_action.types';

const initialState = {
  loggingIn: false,
  reportdata: [],
  error: null,
  message: '',
};

const createReportAndReportColumnReducer = (state = initialState, action) => {
    switch (action.type) {
      case actionTypes.GET_QUERY_REPORT_HEADERS_REQUEST:
      case actionTypes.GET_REPORT_HEADERS_REQUEST:
      case actionTypes.CREATE_REPORT_HEADERS_REQUEST:
      case actionTypes.UPDATE_REPORT_HEADERS_REQUEST:
      case actionTypes.DELETE_REPORT_HEADERS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };

      case actionTypes.CREATE_REPORT_HEADERS_SUCCESS:
      case actionTypes.UPDATE_REPORT_HEADERS_SUCCESS:
      case actionTypes.DELETE_REPORT_HEADERS_SUCCESS:
        return {
          ...state,
          loading: false,
          message: action.payload,
        };
      case actionTypes.GET_REPORT_HEADERS_SUCCESS:
      case actionTypes.GET_QUERY_REPORT_HEADERS_SUCCESS:
        return {
          ...state,
          loading: false,
          reportdata: action.payload,

        }
      case actionTypes.GET_QUERY_REPORT_HEADERS_FAILURE:
      case actionTypes.GET_REPORT_HEADERS_FAILURE:
      case actionTypes.CREATE_REPORT_HEADERS_FAILURE:
      case actionTypes.UPDATE_REPORT_HEADERS_FAILURE:
      case actionTypes.DELETE_REPORT_HEADERS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };

      default:
        return state;
    }
  };

  export default createReportAndReportColumnReducer


